export default {
  default: () => import("/app/main/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layers/tairo/layouts/empty.vue").then(m => m.default || m),
  sidebar: () => import("/app/layers/tairo-layout-sidebar/layouts/sidebar.vue").then(m => m.default || m)
}